<div class="tabs">
    <span *ngFor="let tab of tabs">
        <div class="tab" [ngClass]="{'tab-active' : tabActive == tab}" (click)="tabActive = tab; emitTab(tab)">
            <span [translate]="'app.tabs.' + tab"></span>
        </div>

    </span>
</div>
